import "../Css/Footer.css";
import logo from "../assets/iitchinmaylogo.png";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebook,
  FaWhatsapp,
  FaYoutube
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
 
const Footer = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
 
  return (
    <footer className="super-footer">
      <div className="footer-wrap">
       
        {/* Top Compact Row */}
        <div className="footer-top">
          <div className="footer-logo">
            <img src={logo} alt="IITian's Chinmay Academy" />
            <div className="logo-text">
              <h4>IITian's Chinmay Academy</h4>
              <p>Excellence in Education</p>
            </div>
          </div>
          {/* <div className="contact-quick">
            <a href="tel:+918849189845" className="phone-quick">
              <FaPhoneAlt /> Call: +91 88491 89845
            </a>
            <a href="mailto:asitgodbole@gmail.com" className="email-quick">
              <FaEnvelope /> Email Us
            </a>
          </div> */}
        </div>
 
        {/* Middle Content - Super Compact */}
        <div className="footer-middle">
         
          {/* Links */}
          <div className="footer-box">
            <h5>Links</h5>
            <div className="links-compact">
              <Link to="/" className={isActive("/") ? "active" : ""}>Home</Link>
              <Link to="/about-us">About</Link>
              <Link to="/jee-coaching-in-vadodara">IIT-JEE</Link>
              <Link to="/neet-coaching-in-vadodara">NEET</Link>
              <Link to="/foundation-classes-in-vadodara">Foundation</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
 
          {/* Contact */}
          <div className="footer-box">
            <h5>Contact</h5>
            <div className="contact-compact">
              <div className="contact-line">
                <FaPhoneAlt className="icon" />
                <a href="tel:+918849189845">+91 88491 89845</a>
              </div>
              <div className="contact-line">
                <FaEnvelope className="icon" />
                <a href="mailto:asitgodbole@gmail.com">asitgodbole@gmail.com</a>
              </div>
              <div className="contact-line">
  <FaMapMarkerAlt className="icon" />
  <a 
    href="https://maps.app.goo.gl/bwLXLqYeSKrNx5iQ6"
    target="_blank"
    rel="noopener noreferrer"
  >
    SF-9&10, Shivalay 2, Vasna Rd, above Kheteshwar, opposite HP petrol pump, Ashwamegh Nagar, Tandalja, Vadodara, Gujarat 390007
  </a>
</div>
            </div>
          </div>
 
          {/* Social & Hours */}
          <div className="footer-box">
            <h5>Connect</h5>
            <div className="social-compact">
              <a href="https://www.instagram.com/iitians.chinmay.academy/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/p/IITians-Chinmay-Academy-100083395326058/" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a
  href="https://wa.me/918849189845"
  target="_blank"
  rel="noopener noreferrer"
>
  <FaWhatsapp />
</a>

              <a href="https://youtube.com/@iitianschinmayacademy9559?si=8I9ZtIRFoZ4mpqL1"><FaYoutube /></a>
            </div>
            {/* <div className="hours-compact">
              <p><strong>Hours:</strong></p>
              <p>Mon-Sat : 10:00 AM - 08:00 PM / 12:00 AM - 12:00AM</p>
              <p>Sun : Closed / 12:00 AM - 12:00 AM</p>
            </div> */}
          </div>
 
        </div>
 
        {/* Bottom Line */}
        <div className="footer-bottom-line">
          <p>© {new Date().getFullYear()} IITian's Chinmay Academy</p>
          <p className="dev-credit">Designed by Mark Digital</p>
        </div>
 
      </div>
    </footer>
  );
};
 
export default Footer;